export default "__VITE_ASSET__df3oRG5g__"